module.exports = "../study/imgs/maps/Kanagawa/S8/Agriculture/Rice/Kanagawa_Rice_MRI_RCP26_Mid.png";